import { StatCard } from "apps/ai-metrics/components/shared/StatCard/StatCard";
import { getMetricHelp } from "apps/ai-metrics/config/metricHelpText";

interface Props {
  cost?: number;
  tokens?: number;
  priorCost?: number;
  priorTokens?: number;
  comparisonEnabled: boolean;
  loading?: boolean;
  error?: boolean;
}

const tokenFormatter = new Intl.NumberFormat("en-US", {
  notation: "compact",
  maximumFractionDigits: 1,
});

const dollarFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

const percentChange = (
  current?: number,
  prior?: number,
): number | undefined => {
  if (current === undefined || prior === undefined || prior === 0) {
    return undefined;
  }
  return Math.round(((current - prior) / prior) * 100);
};

export const AiSpendSection = ({
  cost,
  tokens,
  priorCost,
  priorTokens,
  comparisonEnabled,
  loading,
  error,
}: Props): JSX.Element => {
  const tokenValue =
    tokens === undefined ? undefined : tokenFormatter.format(tokens);
  let costValue = cost === undefined ? undefined : dollarFormatter.format(cost);
  if (costValue == "$0") {
    costValue = "no data";
  }

  const tokenDelta = comparisonEnabled
    ? percentChange(tokens, priorTokens)
    : undefined;
  const costDelta = comparisonEnabled
    ? percentChange(cost, priorCost)
    : undefined;

  return (
    <>
      <StatCard
        label="TOKEN SPEND"
        subtitle="Tokens consumed (all models)"
        value={tokenValue}
        delta={tokenDelta}
        higherIsBetter
        loading={loading}
        pending={!loading && !error && tokens === undefined}
        info={getMetricHelp("TOKEN SPEND")}
      />
      <StatCard
        label="DOLLAR SPEND"
        subtitle="AI cost across engineering"
        value={costValue}
        delta={costDelta}
        higherIsBetter
        loading={loading}
        pending={!loading && !error && cost === undefined}
        info={getMetricHelp("DOLLAR SPEND")}
      />
    </>
  );
};
